import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CURRENCIES } from "@/lib/app-context";

const Field = ({ label, children }) => (
  <div className="space-y-1.5"><Label className="text-xs font-semibold text-slate-600">{label}</Label>{children}</div>
);

export function StaffDialog({ staff, onClose, onSave }) {
  const [form, setForm] = useState({
    id: staff.id, name: staff.name || "", agent_name: staff.agent_name || "",
    joining_date: staff.joining_date || "", base_salary: staff.base_salary ?? "", currency: staff.currency || "INR", active: staff.active ?? true,
  });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    onSave({ ...form, base_salary: Number(form.base_salary || 0) });
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="staff-dialog">
        <DialogHeader><DialogTitle className="font-heading">{staff.id ? "Edit staff" : "Add staff"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Staff name"><Input required value={form.name} onChange={set("name")} data-testid="staff-name-input" /></Field>
          <Field label="Agent name"><Input value={form.agent_name} onChange={set("agent_name")} data-testid="staff-agent-input" /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Date of joining"><Input type="date" value={form.joining_date} onChange={set("joining_date")} data-testid="staff-joining-input" /></Field>
            <Field label="Monthly salary"><Input type="number" min="0" required value={form.base_salary} onChange={set("base_salary")} className="num-input" data-testid="staff-salary-input" /></Field>
          </div>
          <Field label="Salary currency">
            <Select value={form.currency} onValueChange={(v) => setForm({ ...form, currency: v })}>
              <SelectTrigger data-testid="staff-currency-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {Object.values(CURRENCIES).map((c) => (
                  <SelectItem key={c.code} value={c.code} data-testid={`staff-currency-${c.code}`}>{c.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </Field>
          {staff.id && staff.currency && form.currency !== staff.currency && (
            <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md p-2" data-testid="currency-change-warning">
              All past months for this staff will show in {form.currency}. Amounts are not converted.
            </p>
          )}
          <label className="flex items-center gap-3 text-sm">
            <Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} data-testid="staff-active-switch" />
            Active (added to new months)
          </label>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} data-testid="staff-cancel-button">Cancel</Button>
            <Button type="submit" className="bg-teal-600 hover:bg-teal-700" data-testid="staff-save-button">Save</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
